import React from 'react'
import { toast } from 'react-toastify';
import _ from 'lodash';
import layoutStorage from '../storage/Layout';
// import axios from '../axios-common';
import { nest, mapToMenu } from '../utils/menus';
import { withUser } from './User';

import tokenStorage from '../storage/Token';
import api from '../api';
import Menus from './Menus'

const { Provider, Consumer } = React.createContext();

// const MAX_DEPTH = 4;

// const sortByLabel = (a, b) => {
//   return a.label > b.label ? 1 : -1;
// }

const mapRouteToOption = ({ route: { name, path } }) => ({ label: name, value: path });

// function flatMenu(menu) {
//   return mapMenu(menu)
//     .flat(MAX_DEPTH)
//     .map(mapRouteToOption)
//     .sort(sortByLabel);
// }

// function mapMenu(items) {
//   return items.map(
//     ({ items, route }) => route ? route : mapMenu(items)
//   );
// }

// const defaultOptions = flatMenu(defaultMenu);

class MenuProvider extends React.PureComponent {
  state = {
    menu: [],
    menuOptions: [],
    layoutMode: layoutStorage.get() || 'horizontal',
    profileMode: 'top',
    menuLayouts: [
      { label: 'Vertical', command: () => this.handleLayoutMode('overlay') },
      { label: 'Horizontal', command: () => this.handleLayoutMode('horizontal') },
      { label: 'Slim', command: () => this.handleLayoutMode('slim') },
    ],
    currentPageName: '',
  }

  componentDidMount() {
    this.loadMenu();
  }

  componentDidUpdate(prevProps, prevState) {
    const { user } = this.props;
    if (!_.isEqual(user, prevProps.user)) {
      this.loadMenu();
    }
  }

  getUserFromToken = async () => {
    const token = tokenStorage.get();
    if (!token) return { isLogged: false, user: null };
    try {
      const { data: user } = await api.account.users.getCurrentUser();
      return { isLogged: true, user };
    } catch(err) {
      if (err.message === 'Network Error') {
        toast.error('Não foi possivel acessar o servidor');
        return { isLogged: false };
      }
      toast.error(`Erro ao validar o usuário: ${err.message}`);
      return { isLogged: false, user: null };
    }
  }

  // loadMenu = () => {
  //   const { isLogged, user } = this.state;

  //   // const { isLogged: isUserLogged } = await this.getUserFromToken();

  //   try {
      
  //     // const { data } = await axios.get(`/api/account/users/menus`);
  //     // const { data } = await api.account.users.getMenus();
  //     // const { data } = await api.account.users.getMenus(isUserLogged); // API FAKE
  //     const data = MenuItems;
      
  //     const config = { mapTo: mapToMenu, sortBy: sortByLabel };
  //     const menu = nest(data, config);
  //     const menuOptions = data
  //       // .filter(({ route: { path }}) => path)
  //       .map(mapRouteToOption)
  //       // .sort(sortByLabel);
  //     console.log("aqqqqqqqqqq")
  //     console.log(menu)
  //     console.log(menuOptions)
  //     this.setState({ menu, menuOptions });
  //   } catch (err) {
  //     const message = getMessageFromRequest(err);
  //     if (isLogged && user) toast.error(message);
  //   }
  // }

  loadMenu = () => {

    const data = Menus;
    const config = { mapTo: mapToMenu };
    const menu = nest(data, config);
    const menuOptions = data
      .filter(({ route: { path }}) => path)
      .map(mapRouteToOption)
      // .sort(sortByLabel);

    this.setState({ menu, menuOptions });
  }

  handleLayoutMode = layoutMode => this.setState({ layoutMode })
  handleProfileMode = profileMode => this.setState({ profileMode })
  handleCurrentPageName = (currentPageName = '') => this.setState({ currentPageName });

  render() {
    const { children } = this.props;
    const context = {
      ...this.state,
      updatePageName: this.handleCurrentPageName,
    };
    return <Provider value={context}>{children}</Provider>;
  }
}

// Injects the menu state
export function withMenu(Component) {
  return function MenuComponent(props) {
    return (
      <Consumer>
        {context => <Component {...props} {...context} />}
      </Consumer>
    );
  };
}

// Injects the menu state
export function withUpdatePageName(Component) {
  return function PageComponent(props) {
    return (
      <Consumer>
        {({ updatePageName }) => <Component {...props} updatePageName={updatePageName} />}
      </Consumer>
    );
  };
}

export default withUser(MenuProvider);
